export class DetectionData {
    private signedUrl: string;
    private json: Array<DetectionFolder>;
    private size: { w: number, h: number }

    constructor(signedUrl: string, json: any, size: { w: number, h: number }) {
        this.signedUrl = signedUrl;
        this.json = [];
        this.size = size
        if (json)
            json.forEach((cell) => {
                this.json.push(this.jsonToDetectionFolder(cell));
            })
    }

    getSignedUrl(): string { return this.signedUrl; }
    getWholeTchek(): Array<DetectionFolder> { return this.json; }
    getFolder(folder: number | string): DetectionFolder {
        if (!this.json)
            return undefined;

        for (let i = 0; i < this.json.length; i++) {
            if (this.json[i].getName() == folder)
                return this.json[i];
        };
        return undefined;
    }

    reset(signedUrl: string): DetectionData {
        this.signedUrl = signedUrl;
        return this;
    }

    set(signedUrl: string) { this.reset(signedUrl); }

    private jsonToDetectionFolder(jsonFolder: any): DetectionFolder {
        // console.log('transforming folder ',jsonFolder);
        const detectionFolder = new DetectionFolder(jsonFolder.folder);
        jsonFolder.sequence.forEach((pictureData) => {
            for (let i = 0; i < pictureData.pieces.length; i++) {
                pictureData.pieces[i] = this.jsonToPart(pictureData.pieces[i]);
            }
            detectionFolder.push(pictureData as DetectionPicture);
        });
        return detectionFolder;
    }

    private jsonToPart(jsonPart: any): DetectionPart {
        const detectionPart = new DetectionPart(jsonPart.type);
        jsonPart.polygons.forEach((polygon) => {
            // Bypass bad values around 10^-8
            if (polygon.x < 1 && polygon.x > 0) {
                console.log('bypassing polygon with x ', polygon.x)
            } else // TODO: X AND Y ARE INVERTED HERE
                detectionPart.push(new Polygon(polygon.x, polygon.y, this.size));
        });
        return detectionPart;
    }
}

export class DetectionFolder {
    private folderName: string;
    private sequence: Array<DetectionPicture>;

    constructor(folderName?: string) {
        this.folderName = folderName;
        this.sequence = [];
    }

    getName(): string { return this.folderName; }
    getSequence(): Array<DetectionPicture> { return this.sequence; }
    getPictureData(pictureNumber: string | number): DetectionPicture {
        for (let i = 0; i < this.sequence.length; i++) {
            if (this.sequence[i].pictureNumber == pictureNumber)
                return this.sequence[i];
        };
        return undefined;
    }

    setFolder(name: number | string): DetectionFolder {
        this.folderName = typeof name === 'number' ? name.toString() : name;
        return this;
    }

    push(...pictureData: Array<DetectionPicture>) {
        this.sequence.push(...pictureData);
    }
}

export interface DetectionPicture {
    damage_detected?: any;
    pieces: Array<DetectionPart>;
    pictureNumber: number;
}

export class DetectionPart {
    private type: string;
    private polygons: Array<Polygon>;

    constructor(type?: string, polygons?: Array<Polygon>) {
        this.type = type;
        this.polygons = polygons ? polygons : [];
    }

    getPolygons(): Array<Polygon> { return this.polygons; }
    getType(): string { return this.type; }
    push(...polygons: Array<Polygon>): DetectionPart {
        this.polygons.push(...polygons);
        return this;
    }
}

export class Polygon {
    private x: Array<number>;
    private y: Array<number>;
    private size: { w: number, h: number }
    constructor(xs: Array<number>, ys: Array<number>, size: { w: number, h: number }) {
        this.x = xs;
        this.y = ys;
        this.size = size
    }

    toSVGString(relativeTo?: PolygonRelativeTo): string {
        let SVGString = '';
        if (!relativeTo) {
            SVGString += 'M ' + this.x[0] + ' ' + this.y[0] + ' ';
            for (let i = 0; i < this.x.length; i++) {
                SVGString += 'L ' + this.x[i] + ' ' + this.y[i] + ' ';
            }
            SVGString += 'z';
        } else {
            const relativePoly = this.calcRelativePoints();
            SVGString += 'M ' + relativePoly.x[0] * relativeTo.width + ' ' + relativePoly.y[0] * relativeTo.height + ' ';
            for (let i = 0; i < relativePoly.x.length; i++) {
                SVGString += 'L ' + relativePoly.x[i] * relativeTo.width + ' ' + relativePoly.y[i] * relativeTo.height + ' ';
            }
            SVGString += 'z';
        }
        return SVGString;
    }

    toArrayOfPoints(relativeTo?: PolygonRelativeTo, offsetBy?: PolygonOffsetBy): Array<any> {
        const points = [];
        if (!relativeTo) {
            for (let i = 0; i < this.x.length; i++) {
                points.push({
                    x: this.x[i] + (offsetBy ? offsetBy.left : 0),
                    y: this.y[i] + (offsetBy ? offsetBy.top : 0)
                });
            }
        } else {
            const relativePoly = this.calcRelativePoints();
            console.log('relativepoly ', relativePoly);
            for (let i = 0; i < relativePoly.x.length; i++) {
                // console.log('width factor', relativeTo.width, 'width offset ',offsetBy.left,'height factor', relativeTo.height, 'height offset ',offsetBy.top );
                points.push(
                    {
                        x: (relativePoly.x[i] * relativeTo.width) + (offsetBy ? offsetBy.left : 0),
                        y: (relativePoly.y[i] * relativeTo.height) + (offsetBy ? offsetBy.top : 0)
                    });
            }
        }
        return [...points];
    }

    /* HiRes images :
       width: 3088px;
       height: 2076px; */
    calcRelativePoints(): Polygon {
        let xs = [...this.x];
        let ys = [...this.y];
        for (let i = 0; i < this.x.length; i++) {
            xs[i] /= this.size.w;
            ys[i] /= this.size.h;
        }
        return new Polygon(xs, ys, this.size);
    }
}

interface PolygonRelativeTo {
    width: number;
    height: number;
}

interface PolygonOffsetBy {
    top: number;
    left: number;
}


// WEBPACK FOOTER //
// ./src/app/model/detection-data.ts